import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { DEFAULT_DATE_FORMAT, EVENT_DATE_FORMAT } from '@/core/constants/time';

import { getTimeAndDate } from '@/utils/helpers';

dayjs.extend(customParseFormat);

function formatEventDate(dateStr: string | undefined): string | null {
  if (!dateStr || !dayjs(dateStr, DEFAULT_DATE_FORMAT).isValid()) return null;

  return getTimeAndDate({
    dateStr,
    enterFormat: DEFAULT_DATE_FORMAT,
    exitFormat: EVENT_DATE_FORMAT,
  });
}

export function getEventDateDisplay(
  eventDate: string | undefined,
  eventEndDate: string | undefined
): string | null {
  if (!eventDate && !eventEndDate) return null;

  const start = formatEventDate(eventDate);
  const end = formatEventDate(eventEndDate);
  const parts = [start, end].filter((x): x is string => x != null);

  return parts.join(' – ');
}

export function getEventTimeDisplay(
  eventTime: string | undefined,
  eventEndTime: string | undefined
): string {
  if (!eventTime && !eventEndTime) return '';

  const parts = [eventTime?.trim(), eventEndTime?.trim()].filter(Boolean);

  return parts.join(' – ');
}
